
  import Vue from 'vue';
  import Component from 'vue-class-component';
  import {validators} from '@/utils/validations';
  import {Emit, Ref} from 'vue-property-decorator';
  import {AuthApi} from '@/api/auth.api';
  import {take} from 'rxjs/operators';
  import AuthCard from '@/components/Auth/AuthCard.vue';

  @Component({
    components: {AuthCard}
  })
  export default class ForgotPassword extends Vue {
    readonly rules = validators;
    valid = false;
    error = false;
    loading = false;
    email: string = '';
    // @ts-ignore
    @Ref() form: VForm;

    onRecoverPassword() {
      if (this.form.validate()) {
        this.error = false;
        this.loading = true;
        (new AuthApi()).recoverPassword({email: this.email})
          .pipe(take(1))
          .subscribe(
            () => this.onSuccess(),
            (err) => this.onFail()
          )
      }
    }

    @Emit()
    onSuccess(): boolean {
      this.loading = false;
      return true
    }

    @Emit()
    onFail(): boolean {
      this.error = true;
      this.loading = false;
      return false
    }
  }
